import React from 'react';
import axios from 'axios';
import {instance} from '../common';

// 아이디 or 닉네임 중복검사
export function DupliSpan({value,name,duInput,setDuInput}){
    let targetName = '';
    if(name == 'u_login_id'){
        targetName = 'ID';
    }else if(name == 'u_nick'){
        targetName = '닉네임';
    }
    

    const dupli = (e) => {
        const {check} = e.target.dataset;
        
        instance.post('/users/dupli',{
            params: {
                name:  name,
                value: value,
            }
        })
        .then(function (response) {
            // handle success
            const cnt = response.data[0].cnt;
            if(cnt === 1){
                alert("이미 존재하는 "+targetName+" 입니다.");
                if(targetName == 'ID'){
                    setDuInput({
                        ...duInput,
                        du_id:false
                    });
                }else if(targetName == '닉네임'){
                    setDuInput({
                        ...duInput,
                        du_nick:false
                    });
                }
                
            }else{
                alert("사용가능하신 "+targetName+" 입니다.");
                if(targetName == 'ID'){
                    setDuInput({
                        ...duInput,
                        du_id:true
                    });
                }else if(targetName == '닉네임'){
                    setDuInput({
                        ...duInput,
                        du_nick:true
                    });
                }
            }
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        
    }
    
    return (
        <span id={name} className="jungbok" onClick={dupli} value={value} name={name}>중복</span>
        
    )
}

// 회원가입
export function userJoin(inputs){
    instance.post('/users/join',{
        params: {
            obj:  inputs,
        }
    })
    .then(function (response) {
        // handle success
    })
    .catch(function (error) {
        // handle error
        console.log(error);
    })
}
